import React from "react";
import { Icon } from "@chakra-ui/react";

export const CalendarIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM17 13H12V18H17V13Z"
        fill="#1A1A1A"
      />
    </Icon>
  );
};
